<template>
  <Modal ref="modal" class="modal-inquiry-review" :actions="actions" @action="handleAction" immediate>
    <h1>Fall überprüfen lassen</h1>
    <p>Teilen Sie den Fall zum überprüfen um.<br/>
      Der Fall ist für Sie in dieser Zeit nicht verfügbar.</p>
    <form>
      <div class="group">
        <Select
          fill
          label="Überprüfer:in"
          :options="psychologists"
          :value.sync="reviewer"
        />
      </div>
    </form>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';
  import Select from '@/components/ui/inputs/Select';
  import InquiryStatus from '@/objects/InquiryStatus';
  import { Store } from '@/store';

  export default {
    name: 'ModalInquiryReview',
    components: {
      Select,
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      uuid: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        psychologists: [],
        reviewer: null,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'cancel', label: i18n.t('labels.cancel') },
          { value: 'review', label: i18n.t('labels.review') },
        ];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    async created() {
      const users = await this.$sav.api.get('/users/psychologists');
      this.psychologists = users
        .map(user => ({ value: user.uuid, label: user.name }))
        .filter(u => u.value !== Store.uuid);
    },
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        if (action === 'review') {
          const uuid = this.uuid;
          const reviewer = this.reviewer;

          const response = await this.$sav.api.post('/inquiry/review', null, {
            uuid,
            reviewer,
            status: InquiryStatus.REVIEWING,
          });
          if (response) {
            this.$emit('done');
          }
        }
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-inquiry-review {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
